import { inject } from 'vue';
import type RestApiClient from '@/api-clients/rest-api-client';

export function useRestApi() {
  const restApi = inject<RestApiClient>('restApi')!;

  return { restApi };
}
